import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import { Drawer, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { PrimaryButton, ButtonSizeOptions, SecondaryButton, InputText, InputTypeAhead } from "@loanbossinc/component-library";
import moment, { relativeTimeRounding } from "moment";
import { validate } from "isemail";

import { generateCashflows, getConfigItems } from "./cashflowTestHarness.store";
import LegCriteria from "./LegCriteria";
import { validateCap } from "./validation";
import {
  amortizationTypes,
  bizDayAdjustmentReset,
  calculationAdjustment,
  currencyTypes,
  daycount,
  fixedIndices,
  floatingIndices,
  frequency,
  instrumentTypes,
  payOrReceive,
  paymentAdjustment,
  rateTypes,
  resetDayTypes,
  resetTypes,
  rounding,
  roundingConventions,
  stubPeriodTypes,
  whenPaymentOccurs,
  whenResetOccurs,
  resetFrequency,
  resetDay,
  legTypes,
  cashflowTypes,
  hedgeTypes
} from "./configItemValues";

const StyledDateInput = styled(TextField)`&&{
    width: 190px;
    margin-left: 5px;
    margin-right: 5px;
    background-color: #e8e8e8;

    label {
        margin-top: 6px;
        margin-left: 10px;
    }
    && div {
        margin-top: 23px;
        margin-left: 1px;
    }
    && input {
        margin-left: 10px;
    }}
`;

const StyledInputSection = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid #C4C4C4;
    border-top: 0;
`;
const StyledSectionContent = styled.div`
    display: flex;
    flex-direction: row;
    padding: 21px;
`;
const SectionTitle = styled.div`
    width: 170px;
    height: 19px;
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #005AA9;
    margin: 15px;
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 10px;
`;

const LegIndicatorWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: 15px;
    margin-top: 20px;
`;

const LegIndicator = styled.div`
    width: 100px;
    left: 100px;
    background: ${props => (props.isActive ? "#5F6368" : "#FFFFFF")};
    border: 1px solid #5F6368;
    box-sizing: border-box;
    border-radius: ${props => (props.isLeftPill ? "16px 0px 0px 16px" : "0px 16px 16px 0px")};

    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    display: flex;
    align-items: center;
    color: ${props => (props.isActive ? "#FFFFFF" : "#5F6368")};
    justify-content: center;
    height: 36px;
`;

const styles = () => ({
  drawerPaper: {
    width: "80%",
    maxWidth: "800px",
    "white-space": "pre-wrap"
  }
});

const CriteriaDrawer = props => {
  const { classes, isOpen, closeDrawer, generateCashflows } = props;
  const [stepNumber, setStepNumber] = useState(1);
  const [numberOfLegs, setNumberOfLegs] = useState({ text: "One", value: 1 });
  const [cashflowParameters, setCashflowParameters] = useState({
    cashflowType: null,
    hedgeType: null,
    notional: null,
    instrumentTypeId: null,
    startDate: null,
    endDate: null,
    holidayCalculationspayments: null,
    holidayCalculationscalculations: null,
    holidayCalculationsresets: null
  });
  const [legOneParameters, setLegOneParameters] = useState({
    calculationAdj: null,
    calculationDay: null,
    observationShift: null,
    payFrequency: null,
    paymentAdj: null,
    paymentDays: null,
    paymentOccurs: null,
    resetAdj: null,
    resetDay: null,
    resetAnchor: null,
    resetDayType: null,
    resetOffset: null,
    stubPeriodEnd: null,
    stubPeriodStart: null,
    resetOccurs: null,
    rateType: null,
    rate: null,
    index: null,
    spread: null,
    resetType: null,
    resetFrequency: null,
    resetWeekDay: null,
    daycount: null,
    roundingConvention: null,
    roundingMethodology: null,
    legType: null
  });
  const [legTwoParameters, setLegTwoParameters] = useState({
    calculationAdj: null,
    calculationDay: null,
    observationShift: null,
    payFrequency: null,
    paymentAdj: null,
    paymentDays: null,
    paymentOccurs: null,
    resetAdj: null,
    resetDay: null,
    resetAnchor: null,
    resetDayType: null,
    resetOffset: null,
    stubPeriodEnd: null,
    stubPeriodStart: null,
    resetOccurs: null,

    rateType: null,
    rate: null,
    index: null,
    spread: null,
    resetType: null,
    resetFrequency: null,
    resetWeekDay: null,
    daycount: null,
    roundingConvention: null,
    roundingMethodology: null,
    legType: null
  });

  const handleChange = (name, value) => {
    console.log("handleChange", { name, value });
    setCashflowParameters({ ...cashflowParameters, [name]: value });
  };
  const handleLegOneChange = (name, value) => {
    console.log("handleLegOneChange", { name, value });
    setLegOneParameters({ ...legOneParameters, [name]: value });
  };
  const handleLegTwoChange = (name, value) => {
    console.log("handleLegTwoChange", { name, value });
    setLegTwoParameters({ ...legTwoParameters, [name]: value });
  };

  const handleNumberOfLegsChange = value => {
    console.log("handleNumberOfLegsChange", value);
    const text = getNumberTextFromValue(value);
    const numOfLegs = { text, value };
    setNumberOfLegs(numOfLegs);
    setStepNumber(1);
  };

  const handleStepChange = value => {
    console.log("handleStepChange", value);
    setStepNumber(value);
  };

  const handleInstrumentTypeChange = value => {
    console.log("handleInstrumentTypeChange", value);
    handleChange("instrumentTypeId", value);
    if (value === instrumentTypes.Collar) {
      handleNumberOfLegsChange(2);
      handleLegOneChange("hedgeType", hedgeTypes.Cap);
      handleLegTwoChange("hedgeType", hedgeTypes.Floor);
    } else if (value === instrumentTypes.Corridor) {
      handleNumberOfLegsChange(2);
    } else if (value === instrumentTypes.Swap) {
      handleNumberOfLegsChange(2);
      handleLegOneChange("hedgeType", hedgeTypes.Swap);
      handleLegTwoChange("hedgeType", hedgeTypes.Swap);
      handleLegOneChange("rateType", rateTypes.Fixed);
      handleLegTwoChange("rateType", rateTypes.Floating);
    } else if (value === instrumentTypes.Cap) {
      handleNumberOfLegsChange(1);
      handleLegOneChange("hedgeType", hedgeTypes.Cap);
    } else if (value === instrumentTypes.Floor) {
      handleLegOneChange("hedgeType", hedgeTypes.Floor);
    }
  };

  const cloneObject = obj => JSON.parse(JSON.stringify(obj));

  const transformPercentsToDecimals = params => {
    const value = cloneObject(params);
    const percentFields = ["rate", "spread"];
    for (let i = 0; i < percentFields.length; i++) {
      const field = percentFields[i];
      console.log(value[field]);
      if (value[field] && value[field].toString().includes("%")) {
        value[field] = parseFloat(value[field].replace("%", "")) / 100;
      } else if (value[field]) {
        value[field] = parseFloat(value[field]) / 100;
      }
    }

    return value;
  };

  const primaryButtonClick = value => {
    if (numberOfLegs.value === 2 && stepNumber === 1) {
      handleStepChange(value);
    } else if (numberOfLegs.value === 1 || stepNumber === 2) {
      if (validateParameters()) {
        const legOne = transformPercentsToDecimals(legOneParameters);
        const legTwo = transformPercentsToDecimals(legTwoParameters);
        generateCashflows(
          {
            numberOfLegs: numberOfLegs.value,
            baseParams: cashflowParameters,
            legOne,
            legTwo,
            callback: props.closeDrawer
          }
        );
      }
    }
  };

  const validateParameters = () => {
    if (cashflowParameters.instrumentTypeId === instrumentTypes.Cap) {
      return validateCap(cashflowParameters, legOneParameters, legTwoParameters, numberOfLegs);
    }

    return true;
  };

  const getNumberTextFromValue = value => {
    switch (value) {
      case 2:
        return "Two";
      case 3:
        return "Three";
      default:
      case 1:
        return "One";
    }
  };

  const setDefaultCriteria = () => {
    setCashflowParameters({
      cashflowType: "7b7f48e5-5a65-11ec-b9d7-98fa9bde2f84",
      notional: 2000000,
      instrumentTypeId: "fd4f3da3-261c-11ec-a542-98fa9bde2f84",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: "2028-11-01",
      holidayCalculationspayments: "9ad1d853-7d75-11e9-9c8e-0242ac140002",
      holidayCalculationscalculations: "9ad1d853-7d75-11e9-9c8e-0242ac140002",
      holidayCalculationsresets: "9ad1d853-7d75-11e9-9c8e-0242ac140002"
    });
    setLegOneParameters({
      calculationAdj: "9ad1d853-7d75-11e9-9c8e-0242ac140002",
      calculationDay: "1",
      observationShift: "3",
      payFrequency: "bbd95d5d-4688-11e9-82f6-0242ac120002",
      paymentAdj: "9ad1d79e-7d75-11e9-9c8e-0242ac140002",
      paymentDays: "1",
      paymentOccurs: "fd4f3db9-261c-11ec-a542-98fa9bde2f84",
      resetAdj: "9ad1d853-7d75-11e9-9c8e-0242ac140002",
      resetDay: "3",
      resetAnchor: "3",
      resetDayType: "fd4f3dd7-261c-11ec-a542-98fa9bde2f84",
      resetOffset: "3",
      stubPeriodEnd: "fd4f3df6-261c-11ec-a542-98fa9bde2f84",
      stubPeriodStart: "fd4f3df6-261c-11ec-a542-98fa9bde2f84",
      resetOccurs: "fd4f3e49-261c-11ec-a542-98fa9bde2f84",
      rateType: "fd4f3e26-261c-11ec-a542-98fa9bde2f84",
      rate: 4,
      index: "2a7680cd-467f-11e9-82f6-0242ac120002",
      spread: 2,
      resetType: "fd4f3dec-261c-11ec-a542-98fa9bde2f84",
      resetFrequency: "0ab59aed-4cb0-11ec-b8fb-98fa9bde2f84",
      resetWeekDay: "0ab59b38-4cb0-11ec-b8fb-98fa9bde2f84",
      daycount: "fb692b8f-766e-11e9-87b9-0242ac120002",
      roundingConvention: "2b5ff91d-59d9-11ec-b9d7-98fa9bde2f84",
      roundingMethodology: "38f5d966-766c-11e9-87b9-0242ac120002",
      legType: "48e0b1d1-5a64-11ec-b9d7-98fa9bde2f84",
      hedgeType: "fc0fa822-733b-11e9-b768-0242ac120002"
    });
    setLegTwoParameters({
      calculationAdj: "9ad1d853-7d75-11e9-9c8e-0242ac140002",
      calculationDay: "1",
      observationShift: "3",
      payFrequency: "bbd95d5d-4688-11e9-82f6-0242ac120002",
      paymentAdj: "9ad1d79e-7d75-11e9-9c8e-0242ac140002",
      paymentDays: "1",
      paymentOccurs: "fd4f3db9-261c-11ec-a542-98fa9bde2f84",
      resetAdj: "9ad1d853-7d75-11e9-9c8e-0242ac140002",
      resetDay: "3",
      resetAnchor: "3",
      resetDayType: "fd4f3dd7-261c-11ec-a542-98fa9bde2f84",
      resetOffset: "3",
      stubPeriodEnd: "fd4f3df6-261c-11ec-a542-98fa9bde2f84",
      stubPeriodStart: "fd4f3df6-261c-11ec-a542-98fa9bde2f84",
      resetOccurs: "fd4f3e49-261c-11ec-a542-98fa9bde2f84",
      rateType: "fd4f3e26-261c-11ec-a542-98fa9bde2f84",
      rate: 4,
      index: "2a7680cd-467f-11e9-82f6-0242ac120002",
      spread: 2,
      resetType: "fd4f3dec-261c-11ec-a542-98fa9bde2f84",
      resetFrequency: "0ab59aed-4cb0-11ec-b8fb-98fa9bde2f84",
      resetWeekDay: "0ab59b38-4cb0-11ec-b8fb-98fa9bde2f84",
      daycount: "fb692b8f-766e-11e9-87b9-0242ac120002",
      roundingConvention: "2b5ff91d-59d9-11ec-b9d7-98fa9bde2f84",
      roundingMethodology: "38f5d966-766c-11e9-87b9-0242ac120002",
      legType: "48e0b1d1-5a64-11ec-b9d7-98fa9bde2f84",
      hedgeType: "fc0fa822-733b-11e9-b768-0242ac120002"
    });
  };

  const getInstrumentTypes = instrumentTypesArray => {
    if (!cashflowParameters.cashflowType) {
      return [];
    } else if (cashflowParameters.cashflowType === cashflowTypes.Loan) {
      return instrumentTypesArray.filter(x => x.id === instrumentTypes.Loan);
    }

    return instrumentTypesArray.filter(x => x.id !== instrumentTypes.Loan);
  };

  const getPillLabel = stepNumber => {
    switch (cashflowParameters.instrumentTypeId) {
      case instrumentTypes.Corridor:
        return stepNumber === 1 ? "Upper Strike" : "Lower Strike";
      case instrumentTypes.Collar:
        return stepNumber === 1 ? "Cap" : "Floor";
      case instrumentTypes.Swap:
        return stepNumber === 1 ? "Fixed" : "Float";
      default:
        return stepNumber === 1 ? "Leg One" : "Leg Two";
    }
  };

  return (
    <Drawer onClose={closeDrawer} anchor="right" open={isOpen} classes={{ paper: classes.drawerPaper }}>
      <StyledInputSection>
        <SectionTitle onClick={() => setDefaultCriteria()}>Cashflow Information</SectionTitle>
        <StyledSectionContent>
          <InputTypeAhead id="cashflowParameters.cashflowType" name="cashflowParameters.cashflowType" value={cashflowParameters.cashflowType} label="Cashflow Type" options={props.configItems.cashflowTypes} onChange={e => handleChange("cashflowType", e)} displayWith={option => option && option.name} setValueWith={option => option && option.id} variant="filled" className="input" style={{ width: "220px", marginLeft: "5px", marginRight: "5px" }} />
          <InputTypeAhead id="cashflowParameters.instrumentTypeId" name="cashflowParameters.instrumentTypeId" value={cashflowParameters.instrumentTypeId} label="Instrument Type" options={getInstrumentTypes(props.configItems.instrumentTypes)} displayWith={option => option && option.name} setValueWith={option => option && option.id} onChange={e => handleInstrumentTypeChange(e)} variant="filled" className="input" style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }} />
        </StyledSectionContent>
        <StyledSectionContent>
          <InputText placeholder="Notional" label={"Notional ($)"} name="notional" variant="filled" type="number" onChange={e => handleChange(e.target.name, e.target.value)} style={{ width: "220px", marginLeft: "5px", marginRight: "5px" }} value={cashflowParameters.notional} />
        </StyledSectionContent>
        <StyledSectionContent>
          {cashflowParameters.cashflowType === "7b7f48df-5a65-11ec-b9d7-98fa9bde2f84" && <InputTypeAhead id="numberOfLegs" name="numberOfLegs" value={numberOfLegs.value} label="Number of Legs" options={[{ id: 1, name: "One" }, { id: 2, name: "Two" }]} displayWith={option => option && option.name} setValueWith={option => option && option.id} onChange={e => handleNumberOfLegsChange(e)} variant="filled" className="input" style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }} />}
          <StyledDateInput placeholder="Value" label={"Start Date"} name="startDate" type="date" defaultValue={cashflowParameters.startDate} variant="filled" onChange={e => handleChange("startDate", e.target.value)} value={cashflowParameters.startDate} InputLabelProps={{ shrink: true }} />
          <StyledDateInput placeholder="Value" label={"End Date"} name="endDate" type="date" defaultValue={cashflowParameters.endDate} variant="filled" onChange={e => handleChange("endDate", e.target.value)} value={cashflowParameters.endDate} InputLabelProps={{ shrink: true }} />
        </StyledSectionContent>
      </StyledInputSection>

      <StyledInputSection>
        <SectionTitle>Holiday Calculations</SectionTitle>
        <StyledSectionContent>
          <InputTypeAhead id="payments" name="cashflowParameters.holidayCalculationspayments" value={cashflowParameters.holidayCalculationspayments} label="Payments" options={props.configItems.calculationAdjustment} displayWith={option => option && option.name} setValueWith={option => option && option.id} onChange={e => handleChange("holidayCalculationspayments", e)} variant="filled" className="input" style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }} />
          <InputTypeAhead id="calculations" name="cashflowParameters.holidayCalculationscalculations" value={cashflowParameters.holidayCalculationscalculations} label="Calculations" options={props.configItems.calculationAdjustment} displayWith={option => option && option.name} setValueWith={option => option && option.id} onChange={e => handleChange("holidayCalculationscalculations", e)} variant="filled" className="input" style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }} />
          <InputTypeAhead id="resets" name="cashflowParameters.holidayCalculationsresets" value={cashflowParameters.holidayCalculationsresets} label="Resets" options={props.configItems.calculationAdjustment} displayWith={option => option && option.name} setValueWith={option => option && option.id} onChange={e => handleChange("holidayCalculationsresets", e)} variant="filled" className="input" style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }} />
        </StyledSectionContent>
      </StyledInputSection>

      {numberOfLegs.value === 2 &&
        <LegIndicatorWrapper>
          <LegIndicator isActive={stepNumber === 1} isLeftPill onClick={() => handleStepChange(1)}>{getPillLabel(1)}</LegIndicator>
          <LegIndicator isActive={stepNumber === 2} isLeftPill={false} onClick={() => handleStepChange(2)}>{getPillLabel(2)}</LegIndicator>
        </LegIndicatorWrapper>}

      {stepNumber === 1 && <LegCriteria stepNumber={stepNumber} cashflowParameters={cashflowParameters} legParameters={legOneParameters} configItems={props.configItems} handleChange={handleLegOneChange} getNumberTextFromValue={getNumberTextFromValue} />}
      {stepNumber === 2 && <LegCriteria stepNumber={stepNumber} cashflowParameters={cashflowParameters} legParameters={legTwoParameters} configItems={props.configItems} handleChange={handleLegTwoChange} getNumberTextFromValue={getNumberTextFromValue} />}

      <ButtonWrapper>
        <SecondaryButton style={{ marginLeft: 24 }} label={`${"Back"}`} onClick={() => handleStepChange(stepNumber - 1)} size={ButtonSizeOptions.smFluid} disabled={stepNumber === 1} />
        <PrimaryButton style={{ marginLeft: 24 }} label={`${numberOfLegs.value === 2 && stepNumber === 1 ? "Next" : "Submit"}`} onClick={() => primaryButtonClick(stepNumber + 1)} size={ButtonSizeOptions.smFluid} />
      </ButtonWrapper>
    </Drawer>
  );
};

const mapStateToProps = ({ authentication, cashflowTestHarness }) => ({
  authentication,
  ...cashflowTestHarness
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, {
    generateCashflows,
    getConfigItems
  })
)(CriteriaDrawer);
